import ReactPixel from "react-facebook-pixel"
import firebase from "firebase/app"
import "firebase/analytics"

declare const window: any

// SDK initialization

function initFirebase() {
  if (firebase.apps == null || firebase.apps.length === 0) {
    const firebaseConfig = {
      apiKey: "AIzaSyCQeDA4GmePFnmgETY600-l-yEoSIdXOOo",
      authDomain: "sixerdev.firebaseapp.com",
      projectId: "sixerdev",
      storageBucket: "sixerdev.appspot.com",
      messagingSenderId: "684819382558",
      appId: "1:684819382558:web:81a6abb4fa82847ce1890f",
      measurementId: "G-75ZZEX6V2T",
    }

    firebase.initializeApp(firebaseConfig)
  }
}

export const initPixel = () => {
  const advancedMatching: any = {}
  const options = {
    autoConfig: true,
    debug: false,
  }
  ReactPixel.init("276735286902162", advancedMatching, options)
}

// Analytics Functions
export const pushToFirebase = (eventName: any, params?: any) => {
  try {
    initFirebase()
    firebase.analytics().logEvent(eventName, params)
  } catch (e) {
    console.error(e)
  }
}

export const pushPixelPurchaseEvent = (params?: any) => {
  if (params === null) {
    params = {}
  }
  ReactPixel.track("Purchase", params)
}

export const pushToGoogleAnalytics = (eventName?: any) => {
  typeof window !== "undefined" && window.gtag("event", eventName)
}

export const pushPixelLeadEvent = (params?: any) => {
  if (params === null) {
    params = {}
  }
  ReactPixel.track("Lead", params)
}

export const pushPixelCheckoutEvent = (params?: any) => {
  if (params === null) {
    params = {}
  }
  ReactPixel.track("InitiateCheckout", params)
}

// Main function
export const pushClickEvent = (event: any, params?: any) => {
  pushToFirebase(event, params)
  // pushPixelPurchaseEvent(params)
  pushToGoogleAnalytics(event)
}
